var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M2,15A13,13,0,0,1,20.778,3.352,1.3,1.3,0,1,1,19.622,5.68,10.4,10.4,0,1,0,25.4,15a10.518,10.518,0,0,0-.064-1.157,1.3,1.3,0,0,1,2.584-.286A13.137,13.137,0,0,1,28,15,13,13,0,0,1,2,15ZM27.619,4.981a1.3,1.3,0,0,1,0,1.838l-11.7,11.7a1.3,1.3,0,0,1-1.838,0l-3.9-3.9a1.3,1.3,0,1,1,1.838-1.838L15,15.762,25.781,4.981a1.3,1.3,0,0,1,1.838,0Z",
    transform: "translate(-2 -2)",
    fill: "#dc81c1",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickPink);
export default __webpack_public_path__ + "static/media/tick-pink.1ff9fcb036c4a30e8db84e7271c1f9da.svg";
export { ForwardRef as ReactComponent };